import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RetailerDataStoreService } from 'src/app/service/retailer-data-store.service';

@Component({
  selector: 'app-success-screen',
  templateUrl: './success-screen.component.html',
  styleUrls: ['./success-screen.component.scss']
})
export class SuccessScreenComponent implements OnInit {

  constructor(
    private router: Router, 
    private retailerDataStore: RetailerDataStoreService
  ) { }

  ngOnInit(): void {
    // this.goToMainScreen();
  }

  goToMainScreen(): void {
    this.retailerDataStore.triggerDealerDataRefresh();
    this.router.navigate(['/dealers'], { replaceUrl: true });
  }
}